import { paths } from '../../../../../../common/constants/pathVariables';
import { OfferType } from '../../../../../../common/enums';
import { internetSubscriptionsMsg, omaElisaForCompaniesMsg, t } from '../../../../../../common/i18n';
import { BreadCrumbsWithTitle } from '../../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle';
import { Grid } from '../../../../../../components/Grid/Grid';
import { Disclaimer } from '../../../../../../components/OrderSubscriptionSelection/Disclaimer';
import { OrderProductOfferingsSelectionCoCo } from '../../../../../../components/OrderSubscriptionSelection/OrderProductOfferingsSelectionCoCo';
import { OrderProductOfferingsSelectionHeaderCoCo } from './OrderProductOfferingsSelectionHeaderCoCo';

import './OrderSelectionPath.scss';

export const MobileBroadbandSubPathCoCo = () => {
  return (
    <>
      <OrderProductOfferingsSelectionHeaderCoCo
        breadCrumbs={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              { name: t.SEYV(internetSubscriptionsMsg), path: paths.PS_BROADBAND_SUBSCRIPTIONS },
              { name: t.A7CH('New Laitenetti subscription') },
            ]}
          />
        }
      />
      <OrderProductOfferingsSelectionCoCo offerType={OfferType.MOBILE_BROADBAND} />
      <Grid>
        <Disclaimer />
      </Grid>
    </>
  );
};
